import { SET_MONTH_STATS, CLEAR_MONTH_STATS } from '../types'

const initialState = {
    monthStats: null
}

const monthlyStatsReducers = (state = initialState, action) => {
    switch (action.type) {
        case SET_MONTH_STATS:
            return {
                ...state,
                monthStats: action.payload
            }
        case CLEAR_MONTH_STATS:
            return {
                ...state,
                monthStats: null
            }
        default:
            return state
    }
}

export default monthlyStatsReducers
